import type { ReactNode } from "react"

import { useStore } from "zustand"

import { ImpersonationBar } from "@/components/account/ImpersonationBar"
import Footer from "@/components/layout/Footer"
import Header from "@/components/layout/Header"
import { MobileBottomNav } from "@/components/layout/MobileBottomNav"
import { Sidebar } from "@/components/layout/Sidebar"
import { OnboardingWizard } from "@/components/onboarding/OnboardingWizard"
import { store } from "@/lib/store"
import { cn, isEmbed } from "@/lib/utils"

interface Props {
  children: ReactNode
  onLogout: () => void
}

export default function DashboardLayout({ children, onLogout }: Props) {
  const embedHideHeader = useStore(store, (state) => state.embedHideHeader)
  const hideHeader = isEmbed() && embedHideHeader

  return (
    <div
      className={cn(
        "grid h-full grid-rows-[auto_1fr_auto] lg:grid-rows-[auto_minmax(0,1fr)_auto]",
        "lg:grid-cols-[auto_minmax(0,1fr)]",
        "lg:overflow-hidden lg:[contain:paint]",
      )}
    >
      {!hideHeader && (
        <div className="lg:col-span-2">
          <Header onLogout={onLogout} />
        </div>
      )}

      <div className="row-start-2 hidden lg:block lg:min-h-0">
        <Sidebar onLogout={hideHeader ? onLogout : undefined} />
      </div>

      <div className="row-start-2 min-w-0 lg:min-h-0 lg:overflow-y-auto">
        <ImpersonationBar onLogout={onLogout} />
        <main className="grid min-w-0 p-5">{children}</main>
      </div>

      <div className="row-start-3 lg:col-span-2">
        <Footer />
      </div>

      <MobileBottomNav onLogout={onLogout} />

      <OnboardingWizard />
    </div>
  )
}
